import { Dispatch, SetStateAction } from 'react'
import { LocationOnOutlined } from '@mui/icons-material'
import { Box, Grid, Typography, useTheme } from '@mui/material'

import { formatAddress } from '../../../utils/helpers'

import useStyles from './index.styles'

interface IProps {
  folder: IFolderType
  setSelectedFolderId: Dispatch<SetStateAction<number | undefined>>
  selectedFolderId: number | undefined
  showFolderName?: boolean
}

const FolderAddress = (props: IProps) => {
  const { folder, setSelectedFolderId, selectedFolderId, showFolderName } = props
  const classes = useStyles
  const theme = useTheme()

  const isFolderSelected = selectedFolderId === folder.id

  return (
    <Box
      sx={{ ...classes.foldersAddress(theme), ...(isFolderSelected ? classes.selectedFolderAddress(theme) : {}) }}
      onClick={() => setSelectedFolderId(folder.id)}
    >
      <Grid container={true}>
        {showFolderName && folder?.name && (
          <>
            <Grid size={1}></Grid>
            <Grid size={11}>
              <Typography sx={classes.folderName}>{folder.name}</Typography>
            </Grid>
          </>
        )}

        <Grid size={1}>
          <LocationOnOutlined sx={{ ...(isFolderSelected ? classes.selectedAddressIcon(theme) : classes.addressIcon) }} />
        </Grid>

        <Grid className="fs-exclude" size={11}>
          {formatAddress(folder.information.address)}
        </Grid>
      </Grid>
    </Box>
  )
}

export default FolderAddress
